import { Card, Col, Popconfirm, Row, Tabs } from 'antd'
import CustomBreadCrumb from '../../../../components/Common/CustomBreadCrumb'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import StatementForm from '../../../../components/Finance/Statements/AddStatement/StatementForm'
import TransactionsCont from '../../../../components/Finance/Statements/Transactions/TransactionsCont'
import style from '../../../../components/Sales/style.css'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CodeIcon from '../../../../elements/CodeIcon'
import CustomSpin from '../../../../elements/CustomSpin'
import Status from '../../../../elements/Status'
import { strVal } from '../../../../modules/Utils'
import React, { Fragment } from 'react'

function AddStatement(props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    statement,
    remove,
    removing,
    isUpdatable,
    actions,
    handleActions,
    isConfirmed,
    isNew,
  } = props

  const Operations = ({ statement, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      isRemovable={!isConfirmed}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )

  return (
    <CustomSpin spinning={fetching}>
      <Card>
        <Row className={style.pageHeader}>
          <CustomBreadCrumb
            items={[
              { text: 'Finance' },
              { text: 'Statements', link: '#/finance/statements' },
              { text: isNew ? 'New Statements' : statement.code },
            ]}
          />

          {isNew && (
            <>
              <h2 className={style.title}>New Bank Statements</h2>
              <p className={style.paragraph}>View and list banking statements.</p>
            </>
          )}
          {!isNew && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <CodeIcon code={strVal(statement, 'code')} title={'Delivery Code'} />
                  <Status value={strVal(statement, 'status')} />
                  <Operations
                    style={{ marginTop: '10px' }}
                    statement={statement}
                    status={strVal(statement, 'status')}
                  />
                </h3>
              </Col>
              <RefreshButton onClick={fetch} />
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Statement" key="statement">
            <StatementForm ref={formRef} loading={fetching} statement={statement} {...props} />
            <SubmitButton />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Transactions" key="transactions">
            <TransactionsCont statement={statement} />
          </Tabs.TabPane>

          <Tabs.TabPane disabled={isNew} tab="Files" key="files">
            <Documents
              key={statement._rev}
              editable={['Submitted', 'Draft'].includes(statement.status)}
              footer={false}
              category={false}
              owner={statement}
            />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddStatement
